import { API_SUCCESS, API_FAILED, apiAction } from '../core/apiCoreRedux';
const FETCH_CAMERA_DATA = 'FETCH_CAMERA_DATA';
const SET_CAMERA_DATA = 'SET_CAMERA_DATA';
const CLEAR_CAMERA_DATA = 'CLEAR_CAMERA_DATA';
const initialState = [];
const initialAction = {
  type: '',
  payload: []
};

// actions
export const fetchCameraData = (locationId, successCallback = () => { }, failureCallback = () => { }) => ({
  type: FETCH_CAMERA_DATA,
  payload: {
    locationId,
    successCallback,
    failureCallback
  }
});

// Middleware
export const fetchAllCameraMiddleware =
  ({ dispatch }) =>
    (next) =>
      (action) => {
        next(action);
        switch (action.type) {
          case FETCH_CAMERA_DATA:
            const { locationId, successCallback, failureCallback } = action.payload;
            dispatch(
              apiAction({
                url: `:8989/stream?id=${locationId}`,
                actionType: FETCH_CAMERA_DATA,
                meta: { successCallback, failureCallback }
              })
            );
            break;

          case `${FETCH_CAMERA_DATA} ${API_SUCCESS}`:
            action.meta.successCallback(action.payload.cameras);
            break;

          case `${FETCH_CAMERA_DATA} ${API_FAILED}`:
            action.meta.failureCallback();

          default:
          // nothing to be done
        }
      };
